import { Link } from "react-router-dom";

export interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  lastModified?: string;
  schemaData?: Record<string, unknown>[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = "website",
  twitterCard = "summary_large_image",
  lastModified,
  schemaData,
}: SEOProps) {
  const fullTitle = title.includes("51吃瓜网")
    ? title
    : `${title} | 51吃瓜网今日吃瓜资源`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="51吃瓜网" />
      <meta name="robots" content="index, follow" />
      <meta name="geo.region" content="CN" />
      <meta name="geo.placename" content="中国" />
      <meta name="language" content="zh-CN" />
      <meta name="revisit-after" content="1 days" />
      {lastModified && (
        <meta name="last-modified" content={lastModified} />
      )}

      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta
        property="og:description"
        content={ogDescription || description}
      />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="51吃瓜网" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta
        name="twitter:description"
        content={ogDescription || description}
      />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {schemaData &&
        schemaData.map((data, index) => (
          <script
            key={index}
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(data),
            }}
          />
        ))}
    </>
  );
}